import { useSelector } from 'react-redux';
import { order } from '~features';

export default function useOrderRequestState() {
    return useSelector(order.selectors.isCartUpdating);
}
